import { BotBlockingEventManagementConfig } from '@stores/types';

export const PER_PAGE = 100;
export const BATCH_SIZE = 100;

export const getPaginationTotal = (data: unknown[] | undefined, hasMoreData: boolean) => {
  const len = data?.length || 0;
  const batchSize = BATCH_SIZE;
  const isTotalUnknown = len > 0 && len % batchSize === 0;
  return isTotalUnknown && hasMoreData ? len + 1 : len;
};

export const getBotActionVariants = (
  config?: BotBlockingEventManagementConfig,
  isDetectionEnabled?: boolean,
  forTotalBotEvents?: boolean,
) => {
  if (!isDetectionEnabled) {
    return {
      titleVariant: 'disabled',
      iconVariant: 'default' as const,
    };
  }

  if (!config?.enabled) {
    return {
      titleVariant: 'detected',
      iconVariant: 'default' as const,
    };
  }
  switch (config.action) {
    case 'drop':
      return {
        titleVariant: 'dropped',
        iconVariant: 'drop' as const,
      };
    case 'flag':
    default:
      return {
        titleVariant: 'flagged',
        iconVariant: forTotalBotEvents ? ('default' as const) : ('flag' as const),
      };
  }
};
